// Check if the browser supports lazy loading
if ("loading" in HTMLImageElement.prototype) {
  const lazyImages = document.querySelectorAll(
    '.thumbnail-list__item[loading="lazy"], .image_background[loading="lazy"]'
  );

  lazyImages.forEach((lazyImage) => {
    if (lazyImage.hasAttribute("imageset")) {
      const alt = lazyImage.getAttribute("data-alt") || "";
      const src =
        lazyImage.getAttribute("data-bg") || lazyImage.getAttribute("data-src");

      if (src) {
        lazyImage.style.backgroundImage = `url(${src})`;
        lazyImage.setAttribute("alt", alt);
      }
    }
  });
} else {
  console.log("Lazy loading is not supported in this browser.");
}

// Announcement-bar slider
if($(window).width() <= 798){
  const slider = document.querySelector('.slider');
  const slides = document.querySelectorAll('.slide');
  const slideWidth = slides[0].offsetWidth;
  let currentIndex = 0;

  function goToSlide(index) {
    currentIndex = index;
    const offset = -slideWidth * currentIndex;
    slider.style.transform = `translateX(${offset}px)`;
  }

  function nextSlide() {
    if (currentIndex < slides.length - 1) {
      goToSlide(currentIndex + 1);
    } else {
      goToSlide(0);
    }
  }

  setInterval(nextSlide, 2000);
}

var barheight = $('.announcement-bar-section').height();
$('.shopify-section-header-sticky').css('top',barheight);
$(window).resize(function(){
  let barheight = $('.announcement-bar-section').height();
  $('.shopify-section-header-sticky').css('top',barheight);
});

setTimeout(function(){
  let barheight = $('.announcement-bar-section').height();
  $('.shopify-section-header-sticky').css('top',barheight);
},500);

// Lightbox Frame text animated

if($(window).width() <= 767){
  const slider = document.querySelector('.slider');
  const slides = document.querySelectorAll('.slide');
  const slideWidth = slides[0].offsetWidth;
  let currentIndex = 0;
  
  function goToSlide(index) {
    currentIndex = index;
    const offset = -slideWidth * currentIndex;
    slider.style.transform = `translateX(${offset}px)`;
  }
  
  function nextSlide() {
    if (currentIndex < slides.length - 1) {
      goToSlide(currentIndex + 1);
    } else {
      goToSlide(0);
    }
  }
  
  setInterval(nextSlide, 2000);
}


// MenuDrawer
$(document).on("click", ".menu_drawer_close, .menu-drawer__overlay", function () {
  $(this).parents(".menu-drawer-container").removeClass("menu-opening");
  $(".header__icon--menu").attr("aria-expanded", false);
  $("body").removeClass("overflow-hidden-tablet");
  $(".menu-drawer__overlay").removeClass("active");
  setTimeout(() => {
    $(".menu-drawer-container").removeAttr("open");
  }, 100);
});

// Megamenu open
$("summary.header__menu-item").on("mouseover", function (e) {
  $(this).parent().attr("open", true);
  megaMenuImageSlider();
  $(window).trigger("resize");
});

// Megamenu close
$("html").on("mouseover", function (event) {
  var container = $(".megamenu ,.header__submenu"),
    container2 = $("summary.list-menu__item");
  if (
    !container.is(event.target) &&
    container.has(event.target).length === 0 &&
    !container2.is(event.target) &&
    container2.has(event.target).length === 0
  ) {
    $(".header__inline-menu details").removeAttr("open");
  }
});

// Header Megamenu Slider
function megaMenuImageSlider() {
  var swiper = new Swiper(".panel__container.megaimage_slider", {
    freeMode: true,
    speed: 1000,
    grabCursor: true,
    loop: false,
    centeredSlides: false,
    slidesPerView: 6.5,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
$(window).on("load", function () {
  megaMenuImageSlider();
});

// Featured collection
function setSlidersHeight() {
  var allSlides = document.querySelectorAll(".card-wrapper .card__inner");
  let valuesArray = Array.from(allSlides, (slide) => slide.offsetHeight);
  let highestValue = Math.max(...valuesArray);
  $(".card-wrapper .card__inner").css("height", highestValue);
}

// New Arrival
var today = new Date();
var threshold = 90;
$(".card-wrapper").each(function () {
  var getDateProduct = $(this).find(".new-arrival-badge").attr("data-publised-date");
  var matchDate = new Date(getDateProduct);
  var timeDifference = today - matchDate;
  var daysDifference = timeDifference / (1000 * 60 * 60 * 24);
  if (daysDifference <= threshold) {
    $(this).find(".new-arrival-badge").css("display", "block");
  }
});

// if ($(window).width() > 991) {
//   $(".card_product_tilt").tilt({
//     scale: 1.075,
//   });
// }

// Custom collection list
if (window.innerWidth <= 749) {
  var swiper = new Swiper(".collection-slider", {
    freeMode: true,
    grabCursor: true,
    loop: false,
    centeredSlides: false,
    slidesPerView: 1,
    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });
}

// Product Upsell Modal Popup
$(".view_details_btn").click(function () {
  var popup = $(this).attr("data-control");
  $("." + popup).addClass("active");
  $("body").addClass("overflow-hidden");
});

$(".close_popup_btn").click(function () {
  $(this).closest(".popup_wrapper").removeClass("active");
  $("body").removeClass("overflow-hidden");
});

// About Gallery Swiper
var swiper = new Swiper(".about_gallery_content", {
  pagination: ".about_gallery_content .swiper-pagination",
  paginationClickable: true,
  loop: true,
  loopedSlides: 50,
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: false,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: -1,
    stretch: 100,
    depth: 100,
    modifier: 1,
    slideShadows: true,
  },
  spaceBetween: 0,
  navigation: {
    nextEl: ".about_gallery_content .swiper-button-next",
    prevEl: ".about_gallery_content .swiper-button-prev",
  },
  breakpoints: {
    320: {
      coverflowEffect: {
        stretch: 100,
        depth: 100,
        modifier: 2,
      },
    },
    480: {
      coverflowEffect: {
        stretch: 100,
        depth: 100,
        modifier: 2,
      },
    },
    1920: {
      coverflowEffect: {
        rotate: -1,
        stretch: 200,
        depth: 400,
        modifier: 1,
        slideShadows: true,
      },
    },
  },
});

// Initial product variant selection
$(document).ready(function () {
  if ($("#ProductJSON").length) {
    var variantData = JSON.parse($("#ProductJSON").text());
    variantData.options.forEach((option, i) => {
      if (option === "size") {
        variantData.variants.forEach((variant) => {
          if (variant[`option${i + 1}`] === '16"x24"') {
            $(".product-form__input input[value='16\"x24\"']").trigger("click");
          }
        });
      }
    });
  }
});

// Partners logo slider
var swiper = new Swiper(".partner_logo_slide", {
  freeMode: true,
  grabCursor: true,
  loop: true,
  centeredSlides: false,
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
});

// Lightbox product change value id
setTimeout(function () {
  $(document).on("click", ".product-single__variants input", function () {
    var getVal = $(this).val();
    $(".hidden_input_val").val(getVal);
  });
}, 1000);

// Email Validation JS
$("#ContactForm-email, .footer_email, .b2b-input-email").on("keyup", function () {
  validateEmail($(this), $(".contact__button .button, .newsletter-form__button, #b2b_Contact_Submit"));
});

function validateEmail(emailSelector, buttonSelector) {
  var emailId = $(emailSelector).val();
  var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  var emailErrorSelector = ".error_message";
  var button = document.querySelector(buttonSelector);

  if (emailRegex.test(emailId) || emailId === "") {
    $(emailErrorSelector).text("");
    button.classList.remove("dicrease_opacity");
  } else {
    $(emailErrorSelector).text("Invalid email address");
    button.classList.add("dicrease_opacity");
  }
}

// Countdown timer Js
function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
function initializeCountdownTimers() {
  var timers = document.querySelectorAll(".timer");

  timers.forEach(function (timer) {
    var target = parseInt(timer.getAttribute("data-to"));
    var speed = parseInt(timer.getAttribute("data-speed"));
    var current = 0;

    var interval = setInterval(function () {
      if (current >= target) {
        timer.textContent = target;
        clearInterval(interval);
      } else {
        current += Math.ceil(target / (speed / 100));
        timer.textContent = current >= target ? target : current;
      }
    }, 100);
  });
}

function onScroll() {
  var section = document.getElementById("count_amount");
  if (section) {
    if (isInViewport(section)) {
      initializeCountdownTimers();
      window.removeEventListener("scroll", onScroll);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", onScroll);
});

// Upload your image page slider
var sliderThumbnail = new Swiper(".customize_product_thumbnail_slider", {
  slidesPerView: 4,
  direction: "horizontal",
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  breakpoints: {
    480: {
      slidesPerView: 5,
      spaceBetween: 5,
    },
    798: {
      slidesPerView: 4,
      spaceBetween: 5,
    },
    1025: {
      slidesPerView: 5,
      direction: "vertical",
      spaceBetween: 5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
var galleryTop = new Swiper(".customize_product_main_slider", {
  slidesPerView: 1,
  direction: "horizontal",
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  autoHeight: true,
  thumbs: {
    swiper: sliderThumbnail,
  },
});

// Product page matte button
$("#matte-frame").one("click", function () {
  $(".gallerypanda_tooltip .tooltip__info_img").addClass("hover");
  setTimeout(function () {
    $(".gallerypanda_tooltip .tooltip__info_img").removeClass("hover");
  }, 3000);
});

$("#gloss-frame").click(function () {
  $(".product__media-wrapper").removeClass("matte-acrylic");
});
$("#matte-frame").click(function () {
  $(".product__media-wrapper").addClass("matte-acrylic");
});

// Account Page | Tab JS
$(".account-vertical-tab-label .tab-nav-link").click(function () {
  var getId = $(this).attr("id");
  $(".account-vertical-tab-label .tab-nav-link.active-tab").removeClass("active-tab");
  $(this).addClass("active-tab");
  $(".account-vertical-tab-content .tab-info-content.active-tab-content").removeClass("active-tab-content");
  $(`.account-vertical-tab-content .${getId}`).addClass("active-tab-content");

  var tt = $(".account-vertical-tab-label .tab-nav-link").detach();
  $(".account-vertical-tab-label").html(tt);
});

// Upload your image Vertical and Horizontal
$(document).on("click", ".banner_styles label", function () {
  let selfImage = $(this).data("image");
  $(".customize-product-templete .product__media img").attr("src", selfImage).attr("srcset", selfImage);
});

// Search Input validation
$('.search__input').val("");
$('.search__input').focusout(function() {
    var text_val = $(this).val();
    if (text_val === "") {
      $(this).removeClass('has-value');
    } else {
      $(this).addClass('has-value');
    }
});

// Email Validation JS

$('#ContactForm-email').on('keyup', function() {
    validateEmail($('#ContactForm-email'), '.contact__button .button');
});

$('.footer_email').on('keyup', function() {
    validateEmail($('.footer_email'), '.newsletter-form__button');
});
var checkInterval = setInterval(function() {
  var emailInputs = $('.needsclick[type="email"]');
  if (emailInputs.length != 0) {
    clearInterval(checkInterval);
    $('.needsclick[type="email"]').on('keyup', function() {
        validateEmail($('.needsclick[type="email"]'), '.needsclick[type="button"]');
    });
  }else {
  }
}, 1000);
$('.needsclick[type="email"]').on('keyup', function() {
    validateEmail($('.needsclick[type="email"]'), '.needsclick[type="button"]');
});

$('.b2b-input-email').each(function() {
  $(this).on('keyup', function() {
      validateEmail($(this), '#b2b_Contact_Submit');
  });
});

function validateEmail($emailSelector, buttonSelector) {
    var emailId = $emailSelector.val();
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    var $emailErrorSelector = $('.error_message');
    var $button = $(buttonSelector);

    if (emailRegex.test(emailId) || emailId == "") {
        $emailErrorSelector.text('');
        $button.removeClass('dicrease_opacity');
    } else {
        $emailErrorSelector.text('Invalid email address');
        $button.addClass('dicrease_opacity');
    }
}

// Change every 10s 
if (typeof window.changeVideoImage !== 'undefined' && window.changeVideoImage.length > 0) {
  const galleryItems = document.querySelectorAll('.featured-collection-list-product .collection-list .collection-list__item, .custom_collection_list_with_video_and_image .collection-list .collection-list__item');
  function updateGallery() {
      var currentColumnIndex = Math.floor((Date.now() / 5000) % window.changeVideoImage[0].length);
      
      galleryItems.forEach((item, index) => {
          const media = window.changeVideoImage[index][currentColumnIndex];
           var img = item.querySelector('img');
          var video = item.querySelector('video')
         
          if (media.image) {
              img.src = media.image;
              img.srcset = media.image;
          }else if (media.video) {
              video.src = media.video;
          }
      });
       
  }
  updateGallery();
  setInterval(updateGallery,  24 * 60 * 1000);
}

function marqueeSlider() {
  var swiper = new Swiper(".marquee-content-disable .swiper-container", {
    freeMode: true,
    speed: 1000,
    grabCursor: true,
    loop: false,
    centeredSlides: false,
    slidesPerView: 'auto',
    spaceBetween: 40,
    autoplay: {
      delay: 2500,
    },
  });
}

if($(window).width() <= 1024){
  marqueeSlider();
}